import { render, staticRenderFns } from "./External-Descriptions.vue?vue&type=template&id=589a5a23&lang=pug"
import script from "./External-Descriptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./External-Descriptions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports